



















































import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { ISprint, IIssue } from '@/lib/interfaces';
import { getSprintInProject, startSprintInProject, getAllIssues } from '@/services/api.service';
import Datepicker from 'vuejs-datepicker';
import { ru } from 'vuejs-datepicker/dist/locale';
import Project from '@/views/project/Project.vue';

@Component({
  directives: {
    focus,
  },
  components: {
    Datepicker,
  },
})
export default class StartSprint extends Vue {
  private sprint: ISprint = {
    title: '',
  };
  private issues: IIssue[] = [];
  private ru = ru;

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    let sprint: ISprint;
    let issues: IIssue[];
    if (to.query.sprint_id) {
      [sprint, issues] = await Promise.all([
        getSprintInProject(to.params.project_id, to.query.sprint_id as string),
        getAllIssues({ _sprint_id: to.query.sprint_id as string, deleted: false }),
      ]);
      if (sprint.start_at || sprint.end_at) {
        next({ name: 'issue_list' });
      }
    } else {
      next({ name: 'issue_list' });
    }
    next((vm: StartSprint) => {
      if (sprint) {
        vm.sprint = sprint;
        vm.issues = issues;
      }
    });
  }

  private nextDay(date: Date): Date | null {
    if (date) {
      return new Date(new Date(date).setDate(date.getDate() + 1));
    }
    return null;
  }

  private prevDay(date: Date): Date | null {
    if (date) {
      return new Date(new Date(date).setDate(date.getDate() - 1));
    }
    return null;
  }

  private async editFinish() {
    await startSprintInProject(this.$route.params.project_id, this.sprint);
    const sprints = (this.$parent as Project).project!.sprints!;
    const updatedSprint = sprints.find((s) => s._id === this.sprint._id)!;
    updatedSprint.start_at = this.sprint.start_at;
    updatedSprint.end_at = this.sprint.end_at;
    this.$router.push({
      name: 'issue_list',
    });
  }
}
